import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: calc(100% - ${({ theme }) => theme.spacing['3Xl']});
  padding: ${({ theme }) => theme.spacing.xl};
`;
